import script from "./dashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./dashboardPage.vue?vue&type=style&index=0&id=f8aeaab4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8aeaab4"]])

export default __exports__